import React, { Component } from 'react';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";
import HorseRacingNonRunnersContainer from "./HorseRacingNonRunnersContainer";
import PropTypes from "prop-types";

export default class HorseRacingNonRunnersPage extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  render() {
    const { location } = this.props;

    return (
      <StandardPage sport="racing" title="Today's Non-Runners" >
        <div className="main-layout-left-column">
          <HorseRacingNonRunnersContainer location={location} />
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingNonRunnersPage.js